import React from "react";
import { Gift, Check, ArrowRight, Sparkles } from "lucide-react";

const perks = [
  "3 premiers mois de gestion offerts",
  "Sans engagement sur cette période",
  "Un gestionnaire dédié dès le premier jour",
  "Loyers sécurisés par notre GLI",
];

export default function Testimonials() {
  return (
    <section id="avis" className="bg-[#EFEAE1] py-20 lg:py-24">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <div className="overflow-hidden rounded-3xl bg-[#26241F] text-white">
          <div className="grid items-center gap-10 p-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-12 lg:p-14">
            <div>
              <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-[12px] font-semibold uppercase tracking-[0.18em] text-[#d9be8e]">
                <Sparkles className="h-3.5 w-3.5" /> Notre engagement
              </p>
              <h2 className="font-serifDisplay text-[34px] leading-[1.05] lg:text-[50px]">
                Le meilleur avis sera le vôtre.
              </h2>
              <p className="mt-5 max-w-xl text-[17px] leading-relaxed text-white/75">
                Nous préférons vous convaincre par l'expérience plutôt que par les mots des
                autres. Pour apprendre à nous connaître, nous vous offrons
                <span className="font-semibold text-white"> vos 3 premiers mois de gestion</span>.
              </p>

              <ul className="mt-8 grid gap-3 sm:grid-cols-2">
                {perks.map((p, i) => (
                  <li key={i} className="flex items-start gap-3 text-[15px]">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#B08D57] text-[#26241F]">
                      <Check className="h-3 w-3" />
                    </span>
                    <span className="text-white/90">{p}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className="group mt-9 inline-flex items-center gap-2 rounded-md bg-[#B08D57] px-7 py-4 text-[15px] font-semibold text-[#26241F] transition-all hover:bg-[#c19d63] hover:shadow-lg"
              >
                Profiter des 3 mois offerts
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>

              <p className="mt-5 text-[13px] leading-relaxed text-white/45">
                * Offre valable uniquement lorsque Loyaris se charge de la recherche de votre locataire.
              </p>
            </div>

            <div className="flex justify-center">
              <div className="relative flex aspect-square w-full max-w-[340px] flex-col items-center justify-center rounded-3xl border border-[#B08D57]/30 bg-gradient-to-b from-[#B08D57]/15 to-transparent p-8 text-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#B08D57] text-[#26241F]">
                  <Gift className="h-8 w-8" />
                </span>
                <div className="mt-6 font-serifDisplay text-[72px] leading-none text-white">3</div>
                <div className="mt-1 text-[18px] font-semibold text-[#d9be8e]">mois offerts</div>
                <p className="mt-4 text-[13px] leading-relaxed text-white/60">
                  Pour découvrir la sérénité d'une gestion Loyaris, sans risque.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
